import { Dispatch } from 'redux';

import {
  updateGroupName,
  updateGroupParentId,
} from '../../Services/ProgrammationManagerService';

export const createTaskAction = (task: any, taskList: any, parentTask?: any) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: 'PROGRAMMATION_ADD_TASK',
      payload: {
        list: taskList.list,
        task,
        parentTask,
      },
    });

    dispatch({
      type: 'DASHBOARD_LOAD_NONE',
    });
    dispatch({
      type: 'MACRO_LOAD_NONE',
    });
    dispatch({
      type: 'LOOKAHEAD_LOAD_NONE',
    });
    dispatch({
      type: 'WEEKLY_LOAD_NONE',
    });
    dispatch({
      type: 'TASKS_LOAD_NONE',
    });
  };
};

export const updateTaskFieldAction = (task_id: string, fieldName: string, value: string) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: 'PROGRAMMATION_UPDATE_TASK_FIELD',
      payload: {
        task_id,
        fieldName,
        value,
      },
    });

    dispatch({
      type: 'DASHBOARD_LOAD_NONE',
    });
    dispatch({
      type: 'MACRO_LOAD_NONE',
    });
    dispatch({
      type: 'LOOKAHEAD_LOAD_NONE',
    });
    dispatch({
      type: 'WEEKLY_LOAD_NONE',
    });
    dispatch({
      type: 'TASKS_LOAD_NONE',
    });
    dispatch({
      type: 'RESOURCES_RESTRICTIONS_LOAD_NONE',
    });
  };
};

export const updateTaskDateAction = (updatedTask: any, parentTask?: any) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: 'PROGRAMMATION_UPDATE_TASK_DATE',
      payload: {
        updatedTask,
        parentTask,
      },
    });

    dispatch({
      type: 'DASHBOARD_LOAD_NONE',
    });
    dispatch({
      type: 'MACRO_LOAD_NONE',
    });
    dispatch({
      type: 'LOOKAHEAD_LOAD_NONE',
    });
    dispatch({
      type: 'WEEKLY_LOAD_NONE',
    });
    dispatch({
      type: 'TASKS_LOAD_NONE',
    });
    dispatch({
      type: 'RESOURCES_RESTRICTIONS_LOAD_NONE',
    });
  };
};

export const updateTaskProgressAction = (task: any, parentTask?: any, updatedTasks?: any[]) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: 'PROGRAMMATION_UPDATE_TASK',
      payload: {
        task,
        parentTask,
        updatedTasks,
      },
    });

    dispatch({
      type: 'DASHBOARD_LOAD_NONE',
    });
    dispatch({
      type: 'MACRO_LOAD_NONE',
    });
    dispatch({
      type: 'LOOKAHEAD_LOAD_NONE',
    });
    dispatch({
      type: 'WEEKLY_LOAD_NONE',
    });
    dispatch({
      type: 'TASKS_LOAD_NONE',
    });
    dispatch({
      type: 'RESOURCES_RESTRICTIONS_LOAD_NONE',
    });
  }
}

export const updateTaskParentIdAction = (data: any) => {
  return async (dispatch: Dispatch) => {

    const {
      taskList,
      task,
      parentTask,
      oldParentTask,
    } = data

    dispatch({
      type: 'PROGRAMMATION_UPDATE_TASK',
      payload: {
        list:
        taskList.list,
        task,
        parentTask,
        oldParentTask,
      },
    });

    dispatch({
      type: 'DASHBOARD_LOAD_NONE',
    });
    dispatch({
      type: 'MACRO_LOAD_NONE',
    });
    dispatch({
      type: 'LOOKAHEAD_LOAD_NONE',
    });
    dispatch({
      type: 'WEEKLY_LOAD_NONE',
    });
    dispatch({
      type: 'TASKS_LOAD_NONE',
    });
    dispatch({
      type: 'RESOURCES_RESTRICTIONS_LOAD_NONE',
    });

    return true
  };
};

export const updateTaskAction = (task: any, updatedTasks: any[]) => {

  return async (dispatch: Dispatch) => {

    dispatch({
      type: 'PROGRAMMATION_UPDATE_TASK',
      payload: {
        task,
        updatedTasks,
      },
    })

    dispatch({
      type: 'DASHBOARD_LOAD_NONE',
    })
    dispatch({
      type: 'MACRO_LOAD_NONE',
    })
    dispatch({
      type: 'LOOKAHEAD_LOAD_NONE',
    })
    dispatch({
      type: 'WEEKLY_LOAD_NONE',
    })
    dispatch({
      type: 'TASKS_LOAD_NONE',
    })
    dispatch({
      type: 'RESOURCES_RESTRICTIONS_LOAD_NONE',
    })
  }
}

export const updateCostAction = (task_id: string, resource: any) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: 'PROGRAMMATION_UPDATE_COST',
      payload: {
        task_id,
        resource,
      },
    });

    dispatch({
      type: 'DASHBOARD_LOAD_NONE',
    });
    dispatch({
      type: 'MACRO_LOAD_NONE',
    });
    dispatch({
      type: 'LOOKAHEAD_LOAD_NONE',
    });
    dispatch({
      type: 'WEEKLY_LOAD_NONE',
    });
    dispatch({
      type: 'TASKS_LOAD_NONE',
    });
    dispatch({
      type: 'RESOURCES_RESTRICTIONS_LOAD_NONE',
    });
  };
};

export const deleteCostAction = (task_id: string, cost_id: string) => {
  return async (dispatch: Dispatch) => {

    dispatch({
      type: 'PROGRAMMATION_DELETE_COST',
      payload: {
        task_id,
        resource_id: cost_id,
      },
      error: true,
    });

    dispatch({
      type: 'DASHBOARD_LOAD_NONE',
    });
    dispatch({
      type: 'MACRO_LOAD_NONE',
    });
    dispatch({
      type: 'LOOKAHEAD_LOAD_NONE',
    });
  };
};

export const updateRelationsAction = (data: any, addNewRelation: boolean = false) => {
  return async (dispatch: Dispatch) => {

    const {
      relation,
      updatedTasks
    } = data

    dispatch({
      type: 'PROGRAMMATION_UPDATE_RELATIONS',
      payload: {
        relation,
        updatedTasks,
        addNewRelation,
      },
    });

    dispatch({
      type: 'DASHBOARD_LOAD_NONE',
    });
    dispatch({
      type: 'MACRO_LOAD_NONE',
    });
    dispatch({
      type: 'LOOKAHEAD_LOAD_NONE',
    });
    dispatch({
      type: 'WEEKLY_LOAD_NONE',
    });
    dispatch({
      type: 'TASKS_LOAD_NONE',
    });
    dispatch({
      type: 'RESOURCES_RESTRICTIONS_LOAD_NONE',
    });

    return true
  };
};

export const removeRelationAction = (data: any) => {
  return async (dispatch: Dispatch) => {

    const {
      relation_id,
      updatedTasks,
    } = data

    dispatch({
      type: 'PROGRAMMATION_DELETE_RELATION',
      payload: {
        relation_id,
        updatedTasks,
      },
    });

    dispatch({
      type: 'DASHBOARD_LOAD_NONE',
    });
    dispatch({
      type: 'MACRO_LOAD_NONE',
    });
    dispatch({
      type: 'LOOKAHEAD_LOAD_NONE',
    });
    dispatch({
      type: 'WEEKLY_LOAD_NONE',
    });
    dispatch({
      type: 'TASKS_LOAD_NONE',
    });
    dispatch({
      type: 'RESOURCES_RESTRICTIONS_LOAD_NONE',
    });

    return true
};
};

export const updateConstraintsAction = (data: any) => {
  return async (dispatch: Dispatch) => {

    const {
      task,
      parentTask,
    } = data

    dispatch({
      type: 'PROGRAMMATION_UPDATE_CONSTRAINTS',
      payload: {
        task,
        parentTask,
      },
    });

    dispatch({
      type: 'DASHBOARD_LOAD_NONE',
    });
    dispatch({
      type: 'MACRO_LOAD_NONE',
    });
    dispatch({
      type: 'LOOKAHEAD_LOAD_NONE',
    });
    dispatch({
      type: 'WEEKLY_LOAD_NONE',
    });
    dispatch({
      type: 'TASKS_LOAD_NONE',
    });
    dispatch({
      type: 'RESOURCES_RESTRICTIONS_LOAD_NONE',
    });

    return true
};
};

export const updateResponsiblesAction = (data: any) => {
  return async (dispatch: Dispatch) => {

    const {
      task,
      parentTask,
    } = data

    dispatch({
      type: 'PROGRAMMATION_UPDATE_RESPONSIBLES',
      payload: {
        task,
        parentTask,
      },
    });

    dispatch({
      type: 'DASHBOARD_LOAD_NONE',
    });
    dispatch({
      type: 'MACRO_LOAD_NONE',
    });
    dispatch({
      type: 'LOOKAHEAD_LOAD_NONE',
    });
    dispatch({
      type: 'WEEKLY_LOAD_NONE',
    });
    dispatch({
      type: 'TASKS_LOAD_NONE',
    });
    dispatch({
      type: 'RESOURCES_RESTRICTIONS_LOAD_NONE',
    });

    return true
  };
}

export const createGroupAction = (taskList: any) => {

  return async (dispatch: Dispatch) => {
    dispatch({
      type: 'PROGRAMMATION_ADD_GROUP',
      payload: {
        list: taskList.list,
      },
    });

    dispatch({
      type: 'DASHBOARD_LOAD_NONE',
    });
    dispatch({
      type: 'MACRO_LOAD_NONE',
    });
    dispatch({
      type: 'LOOKAHEAD_LOAD_NONE',
    });
    dispatch({
      type: 'WEEKLY_LOAD_NONE',
    });
    dispatch({
      type: 'TASKS_LOAD_NONE',
    });
  }
}

export const updateGroupNameAction = (
  group_id: string,
  name: string,
  project_id: string
) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: 'UPDATE_GROUP_NAME',
      payload: {
        group_id,
        name,
      },
    });

    dispatch({
      type: 'DASHBOARD_LOAD_NONE',
    });
    dispatch({
      type: 'MACRO_LOAD_NONE',
    });
    dispatch({
      type: 'LOOKAHEAD_LOAD_NONE',
    });
    dispatch({
      type: 'WEEKLY_LOAD_NONE',
    });
    dispatch({
      type: 'TASKS_LOAD_NONE',
    });
    dispatch({
      type: 'RESOURCES_RESTRICTIONS_LOAD_NONE',
    });
  };
};

export const updateGroupParentIdAction = (
  group_id: string,
  parent_id: string,
  project_id: string
) => {
  return async (dispatch: Dispatch) => {
    const [error, taskList ] = await updateGroupParentId(
      group_id,
      parent_id,
      project_id
    );

    if (error) {
      console.log('updateGroupParentIdAction', error)

      return;
    }

    dispatch({
      type: 'PROGRAMMATION_UPDATE_LIST',
      payload: {
        list: taskList.list,
      },
    });
    dispatch({
      type: 'DASHBOARD_LOAD_NONE',
    });
    dispatch({
      type: 'MACRO_LOAD_NONE',
    });
    dispatch({
      type: 'LOOKAHEAD_LOAD_NONE',
    });
    dispatch({
      type: 'WEEKLY_LOAD_NONE',
    });
    dispatch({
      type: 'TASKS_LOAD_NONE',
    });
    dispatch({
      type: 'RESOURCES_RESTRICTIONS_LOAD_NONE',
    });
  };
};

export const setCommentsAction = (task_id: string, comments: any[]) => {

  return async (dispatch: Dispatch) => {

    dispatch({
      type: 'PROGRAMMATION_SET_COMMENTS',
      payload: {
        task_id,
        comments: comments.map((comment: any) => {

          return {
            ...comment,
            user: comment.user._id,
          }
        }),
      },
    });
    dispatch({
      type: 'MACRO_LOAD_NONE',
    });
    dispatch({
      type: 'LOOKAHEAD_LOAD_NONE',
    });
    dispatch({
      type: 'WEEKLY_LOAD_NONE',
    });
    dispatch({
      type: 'TASKS_LOAD_NONE',
    });
  }
};

export const addDocumentAction = (document: any) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: 'PROGRAMMATION_ADD_DOCUMENT',
      payload: {
        document,
      },
    });

    return true
  };
};

export const updateDocumentAction = (document_id: string, name: string) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: 'PROGRAMMATION_UPDATE_DOCUMENT',
      payload: {
        document_id,
        name,
      },
    });

    return true
  };
};

export const deleteDocumentAction = (document_id: string) => {

  return {
    type: 'PROGRAMMATION_DELETE_DOCUMENT',
    payload: {
      document_id,
    },
  }
}

export const deleteTaskAction = (task_id: string, parentTask: any, taskList: any) => {

  return async (dispatch: Dispatch) => {

    dispatch({
      type: 'PROGRAMMATION_REMOVE_TASK',
      payload: {
        task_id,
        parentTask,
        list: taskList.list,
      }
    })

    dispatch({
      type: 'DASHBOARD_LOAD_NONE',
    });
    dispatch({
      type: 'MACRO_LOAD_NONE',
    });
    dispatch({
      type: 'LOOKAHEAD_LOAD_NONE',
    });
    dispatch({
      type: 'WEEKLY_LOAD_NONE',
    });
    dispatch({
      type: 'TASKS_LOAD_NONE',
    });
    dispatch({
      type: 'RESOURCES_RESTRICTIONS_LOAD_NONE',
    });
  }
}

export const deleteGroupAction = (taskList: any, deleted_tasks_ids: string[]) => {

  return async (dispatch: Dispatch) => {

    dispatch({
      type: 'PROGRAMMATION_DELETE_GROUP',
      payload: {
        list: taskList.list,
        deleted_tasks_ids,
      }
    })

    dispatch({
      type: 'DASHBOARD_LOAD_NONE',
    });
    dispatch({
      type: 'MACRO_LOAD_NONE',
    });
    dispatch({
      type: 'LOOKAHEAD_LOAD_NONE',
    });
    dispatch({
      type: 'WEEKLY_LOAD_NONE',
    });
    dispatch({
      type: 'TASKS_LOAD_NONE',
    });
  }
}
